import { render, staticRenderFns } from "./editnote.html?vue&type=template&id=79de49df&scoped=true&"
import script from "./editnote.js?vue&type=script&lang=js&"
export * from "./editnote.js?vue&type=script&lang=js&"
import style0 from "./editnote.sass?vue&type=style&index=0&id=79de49df&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79de49df",
  null
  
)

component.options.__file = "editnote.vue"
export default component.exports